"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    formatPercent: function() {
        return formatPercent;
    },
    formatPercentFromPercent: function() {
        return formatPercentFromPercent;
    }
});
const _validation = require("../utils/validation");
const formatPercent = (input, fractionDigits = 0)=>{
    (0, _validation.assertIsTrue)(fractionDigits >= 0 && fractionDigits <= 100, 'fractionDigits must be between 0 and 100.');
    if (!(0, _validation.isNumeric)(input) || !Number.isFinite(input)) {
        return '';
    }
    return `${input.toFixed(fractionDigits)}%`;
};
const formatPercentFromPercent = (input, fractionDigits = 0)=>{
    if (!(0, _validation.isNumeric)(input) || !Number.isFinite(input)) {
        return '';
    }
    const converted = input * 100.0;
    return formatPercent(converted, fractionDigits);
};

//# sourceMappingURL=percent.js.map